import { render, staticRenderFns } from "./sso-logout.vue?vue&type=template&id=4a19b881&"
import script from "./sso-logout.vue?vue&type=script&lang=js&"
export * from "./sso-logout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports